import Button from "../../../Button";
import { getImgUrl } from "../../../../utills";
import useText from "../../../../hooks/useText";
import InputText from "../../../FormFiled/InputText";
import RenderIfAvailable from "../../../RenderIfAvailable";
import useHandleForm from "../../../../hooks/useHandleForm";
import { SUBMIT_REQUEST } from "../../../../GlobalConstant";
import { ALT_KEY, COMPLETED_ICN } from "../../../../GlobalConstant/image";
import { submitLead } from "../../../../features/MIFIPlansList/api/MIFIPlansList.api";
import { CALL_BACK_FORM_HEADING, CALL_BACK_FORM_DES, CALL_BACK_REQUEST_SUBMITTED_TEXT } from "../../constant";

import styles from "../HelpWidgetsFormModal/HelpWidgetsFormModal.module.scss";

const CallBackForm = ({ formSchema, translations }) => {

  const { values,
    errors,
    isSubmitting,
    submitted,
    handleChange,
    handleSubmit
  } = useHandleForm({
    formSchema, onSubmit: async (data) => {
      await submitLead(data);
    }
  })

  const { getText } = useText()

  return <div>
    <div className={styles.header}>{getText(CALL_BACK_FORM_HEADING)}</div>
    <div className={styles["form-description"]}>{getText(CALL_BACK_FORM_DES)}</div>
    <div className={styles["form-field-wrapper"]}>
      {
        formSchema?.map((item) => <InputText
          key={`callback_form_${item?.name}`}
          field={{ ...item, placeholder: getText(item.placeholder) }}
          handleChange={handleChange}
          error={errors[item.name]}
          value={values[item?.name]}
        />)
      }
    </div>
    <Button text={getText(SUBMIT_REQUEST)} callBack={handleSubmit} isSubmitting={isSubmitting} />
    <RenderIfAvailable value={submitted}>
      <div className={`${styles.successMsgWrapper}`}>
        <div className={styles["successIcn"]}><img src={getImgUrl(COMPLETED_ICN)} alt={ALT_KEY.SUCCESS} /></div>
        <div>
          {getText(translations?.CALL_BACK_REQUEST_SUBMITTED_TEXT ?? CALL_BACK_REQUEST_SUBMITTED_TEXT)}
        </div>
      </div>
    </RenderIfAvailable>
  </div>
}

export default CallBackForm